import styled from 'styled-components';
import Clickable from '@prisjakt/ui-clickable';

export const TextLink = styled(Clickable)`
  color: ${p => p.theme.text.callToAction};

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
    text-decoration: underline;
  }
`;
